import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/__authed/m/complaints")({
	component: Outlet,
});
